import { Typography, TypographyProps } from '@mui/material'
import { ReactNode } from 'react'
import { useIntl } from 'react-intl'

export interface TextOrTranslationProps {
  text?: ReactNode
  translationId?: string
}

export const TextOrTranslation = ({
  text,
  translationId
}: TextOrTranslationProps) => {
  const { formatMessage } = useIntl()
  return (
    <>{text || (translationId ? formatMessage({ id: translationId }) : null)}</>
  )
}

export interface StyledTextOrTranslationProps extends TextOrTranslationProps {
  typographyProps?: TypographyProps
}

export const StyledTextOrTranslation = ({
  typographyProps,
  ...rest
}: StyledTextOrTranslationProps) => {
  return (
    <Typography {...typographyProps}>
      <TextOrTranslation {...rest} />
    </Typography>
  )
}
